import { lang } from '@umu/ukit-lang';
import { OBJ_TYPE as SEARCH_OBJ_TYPE } from '@umu/umu-types';
import { ISearchObjLabelMap } from '@umu/umu-search/src/searchInputForContent/common/interface';

export const headerTypeData = {
    umu: 1,
    use: 2,
};

export const defaultRecommendData = {
    popular: [],
    LenovoCourse: [],
    historySearch: [],
    historyCourse: [],
};

export enum LIST_TYPE {
    CORRELATION_LIST = 0,
    POPULAR_LIST = 1,
    NEW_LIST = 2,
}

export type IParam = {
    [propName in string]: string | number | LIST_TYPE;
};

export const searchObjLabelMap: ISearchObjLabelMap = {
    [SEARCH_OBJ_TYPE.group]: {
        label: lang('课程'),
        class: 'label-course',
    },
    [SEARCH_OBJ_TYPE.program]: {
        label: lang('学习项目'),
        class: 'label-program',
    },
    [SEARCH_OBJ_TYPE.circle]: {
        label: lang('学习圈'),
        class: 'label-circle',
    },
    [SEARCH_OBJ_TYPE.element]: {
        label: lang('小节'),
        class: 'label-element',
    },
};

export const getCircleSort = (activeSortType: LIST_TYPE) => {
    switch (activeSortType) {
        case LIST_TYPE.POPULAR_LIST:
            return LIST_TYPE.CORRELATION_LIST;
        case LIST_TYPE.NEW_LIST:
            return LIST_TYPE.POPULAR_LIST;
        default:
            return activeSortType;
    }
};

export const getFilterParams = (param: IParam) => {
    const params: IParam = {};
    for (const i in param) {
        const item = param[i];
        if (item && item !== null) {
            params[i] = item;
        }
    }
    if (params['recall_modules'] === 'circle_v2' && params.sort) {
        params.sort = getCircleSort(params.sort as LIST_TYPE);
    }
    return params;
};

export const getParametersByObj = (param: Object) => {
    let result = '';
    if (param) {
        for (const i in param) {
            const item = (param as any)[i];
            if (item !== '') {
                const split = result === '' ? '' : '&';
                result += `${split}${i}=${item}`;
            }
        }
    }
    return result;
};
